export default __webpack_public_path__ + "static/media/airquality.08773924.png";